import React from 'react';
import CareFeatureNav from '@/components/CareFeatureNav';
import BrandLogo from '@/components/brand/BrandLogo';
import BackToApp from '@/components/BackToApp';
import './care-page.css';

export default function CarePageHeader({
  current,
  kicker,
  title,
  lede,
  titleTestId,
  ledeTestId,
  children,
  showBackToApp = true,
}) {
  return (
    <header className="care-page-header">
      {showBackToApp ? <BackToApp /> : null}
      <div className="care-page-brand">
        <BrandLogo size="md" />
      </div>
      <CareFeatureNav current={current} showBrand={false} />
      {kicker ? <p className="care-page-kicker">{kicker}</p> : null}
      <h1 className="care-page-title" data-testid={titleTestId}>{title}</h1>
      {lede ? (
        <p className="care-page-lede" data-testid={ledeTestId}>{lede}</p>
      ) : null}
      {children}
    </header>
  );
}
